import { Component, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Profile } from '../_models/profile';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  profileForm: FormGroup;
  userprofile: Profile;
  validationErrors: any[] = [];

  constructor(private customerService: CustomerService, private toastr: ToastrService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
  

    this.profileForm = this.fb.group({
      'companyName': ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      contact: ['', Validators.required],
      address: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      zipcode: ['', Validators.required],
      country: ['', Validators.required],
      vatNumber: ['', Validators.required]
    });

    this.customerService.getProfile().subscribe(userprofile =>
      {
        this.userprofile = userprofile;  
        this.profileForm.setValue({
          'companyName': userprofile.companyName,
          contact: userprofile.contact,
          address: userprofile.address,
          address2: userprofile.address2,
          city: userprofile.city,
          zipcode: userprofile.zipcode,
          country: userprofile.country,
          vatNumber: userprofile.vatNumber
        });      
      });

   }



  updateProfile(){
    if (!this.profileForm.valid) { return; }

    console.log('update profile');
    this.userprofile.companyName = this.profileForm.value.companyName;
    this.userprofile.contact = this.profileForm.value.contact;
    this.userprofile.address = this.profileForm.value.address;
    this.userprofile.address2 = this.profileForm.value.address2;
    this.userprofile.city = this.profileForm.value.city;
    this.userprofile.zipcode = this.profileForm.value.zipcode;
    this.userprofile.country = this.profileForm.value.country;
    this.userprofile.vatNumber = this.profileForm.value.vatNumber;
    this.customerService.updateProfile(this.userprofile).subscribe(() => {
      this.validationErrors = [];
      this.toastr.success('Profile updated successfully');
      this.profileForm.reset(this.userprofile);
   }, error => {
    this.toastr.error('Profile update failed');
    this.validationErrors = error;
  });
  }

}
